import { render, staticRenderFns } from "./ClientBookingForm.vue?vue&type=template&id=d22b6116&scoped=true"
import script from "./ClientBookingForm.vue?vue&type=script&lang=js"
export * from "./ClientBookingForm.vue?vue&type=script&lang=js"
import style0 from "./ClientBookingForm.vue?vue&type=style&index=0&id=d22b6116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22b6116",
  null
  
)

export default component.exports